import {
  Button,
  Modal,
  Select,
  Checkbox,
  Collapse,
  message,
  Form,
  Input,
  Radio,
  Switch,
} from "antd";
import React, { useState, useEffect } from "react";
import coparent from "../../Assets/Co-parent/Co-Parent-Calendar-Icon.png";
import "../../App.css";
import "../InviteCapture/Capture.css";
import "./Coparent.css";
import ReminderModalCoparent from "./ReminderModalCoparent";
import ColorDropdownWithName from "./ColorDropdownWithName";
import {
  DeleteOutlined,
  EditOutlined,
  DownOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import FloatLabel from "../FloatLabel"; // Import FloatLabel component
import ChooseDays from "./ChooseDays";
import ChooseTime from "./ChooseTime";
import CoParentCalender from "./CoParentCalender";
import CoParentCalendarNew from "./CoParentCalendarNew";

import { URL } from "../../helper/Mainurl";
import ReminderModal from "../Email/ReminderModal";
const { Panel } = Collapse;
const EditCoparent = ({
  isOpen,
  onCancel,
  couples,
  alreadySet,
  colorHeaderBackground,
  startDate,
  endDate,
  getCoparentsMetaData,
  fetchAndSetEvents,
}) => {
  const token = localStorage.getItem("authToken");
  const [step, setStep] = useState(alreadySet ? 2 : 1);
  const [addParent, setAddParent] = useState(false);
  const [isModalOpenChooseTime, setIsModalOpenChooseTime] = useState(false);
  const [showParent1Details, setShowParent1Details] = useState(false);
  const [showParent2Details, setShowParent2Details] = useState(false);
  const [permissionOptions, setPermissionOptions] = useState([]);
  const [scheduleTypeOptions, setScheduleTypeOptions] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [setupId, setSetupId] = useState(null);
  const [hasSentInvite, setHasSentInvite] = useState(alreadySet);
  const [metadata, setMetadata] = useState({});
  const [coParents, setCoParents] = useState([
    {
      email: "",
      isExpanded: true,
      permission: 1,
      children: [],
      emailError: "",
      isAddingChild: false,
      newChildName: "",
      removedChildren: [],
    },
  ]);
  const [deletedCombinations, setDeletedCombinations] = useState([]);
  const [editingIndex, setEditingIndex] = useState({
    parent: null,
    child: null,
  });
  const [editModeName, setEditModeName] = useState("");
  const handleOpenModal = (comboId, childId = null) => {
    setActiveComboId(comboId);
    setActiveChildId(childId);
    setIsModalOpenChooseDay(true);
  };
  const handleOpenModalTime = (comboId, childId = null) => {
    // console.log("handleOpenModalTime", comboId, childId);
    setActiveComboId(comboId);
    setActiveChildId(childId);
    setIsModalOpenChooseTime(true);
  };

  const handleCloseModalTime = () => setIsModalOpenChooseTime(false);

  const [value, setValue] = useState(1);

  const colorOptions = [
    { value: "#9b59b6" },
    { value: "#3498db" },
    { value: "#e74c3c" },
    { value: "#2ecc71" },
    { value: "#f39c12" },
    { value: "#e91e63" },
  ];

  const ColorDropdown = ({ value, onChange }) => (
    <Select
      value={value}
      onChange={onChange}
      bordered={false}
      suffixIcon={<DownOutlined />}
      style={{ width: 40, padding: 0, background: "transparent" }}
      dropdownStyle={{ padding: "6px 8px" }}
      options={colorOptions.map((color) => ({
        value: color.value,
        label: (
          <span
            style={{
              display: "inline-block",
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: color.value,
              border:
                value === color.value ? "2px solid #999" : "1px solid #ccc",
            }}
          />
        ),
      }))}
    />
  );
  const [isModalOpenChooseDay, setIsModalOpenChooseDay] = useState(false);
  const [activeComboId, setActiveComboId] = useState(null); // for combo.id
  const [activeChildId, setActiveChildId] = useState(null);
  const [notificationSettings, setNotificationSettings] = useState({
    push: 0,
    email: 0,
    calendar: 0,
    reminderEnabled: 0,
  });
  const [sameScheduleForAll, setSameScheduleForAll] = useState(0);
  const [reminder, setReminder] = useState(null);
  const [parentCombinationsV2, setParentCombinationsV2] = useState([]);
  const [parentCombinations, setParentCombinations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatedLoading, setUpdateLoading] = useState(false);

  const couple = couples.find((c) => c.id === activeComboId);
  // useEffect(() => {
  //   console.log("ParentCombinations", parentCombinations);
  // }, [parentCombinations]);
  useEffect(() => {
    // console.log("ParentCombinationsV2", parentCombinationsV2);
  }, [parentCombinationsV2]);
  useEffect(() => {
    if (isOpen && !hasSentInvite) {
      setStep(1);
    }
  }, [isOpen, hasSentInvite]);
  useEffect(() => {
    if (isOpen && hasSentInvite) {
      getCoparentEdit();
      getCoparentSedule();
      getStepThree();
    }
  }, [isOpen, step]);
  // console.log(hasSentInvite, "hasSentInvite");

  const handleSaveDays = (
    parent1Days,
    parent2Days,
    scheduleType,
    isSameScheduleForAll
  ) => {
    setParentCombinations((prev) =>
      prev.map((combo) => {
        if ((combo.id || combo.coparent_combination_id) !== activeComboId)
          return combo;

        // normalize scheduleType object
        const normalizedScheduleType =
          scheduleType.id === 42
            ? {
                id: 42,
                label: `<strong>Parent 1:</strong> ${parent1Days.join(
                  ", "
                )} <br> <strong>Parent 2:</strong> ${parent2Days.join(", ")}`,
              }
            : { id: scheduleType.id, label: scheduleType.label };

        if (isSameScheduleForAll) {
          const cleanedChildren = combo.children.map((child) => {
            // const { parent1Days, parent2Days, scheduleType, ...rest } = child;
            return {
              ...child,
              scheduleType: normalizedScheduleType,
              schedule_type_id: normalizedScheduleType.id,
              parent1: {
                ...child.parent1,
                days: parent1Days,
                selected_days: parent1Days,
              },
              parent2: {
                ...child.parent2,
                days: parent2Days,
                selected_days: parent2Days,
              },
            };
          });

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType: normalizedScheduleType,
            parent1: { ...combo.parent1, days: parent1Days },
            parent2: { ...combo.parent2, days: parent2Days },
            children: cleanedChildren,
          };
        } else {
          const updatedChildren = combo.children.map((child) =>
            (child?.child_id || child?.id) === activeChildId
              ? {
                  ...child,
                  parent1Days,
                  parent2Days,
                  scheduleType: normalizedScheduleType,
                  schedule_type_id: normalizedScheduleType.id,
                  parent1: {
                    ...child.parent1,
                    days: parent1Days,
                    selected_days: parent1Days,
                  },
                  parent2: {
                    ...child.parent2,
                    days: parent2Days,
                    selected_days: parent2Days,
                  },
                }
              : child
          );

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType: undefined, // clear combo-level scheduleType
            parent1: {
              ...combo.parent1,
              days: parent1Days?.length
                ? parent1Days.map((d) => ({ day: d }))
                : combo.parent1?.days || [],
            },
            parent2: {
              ...combo.parent2,
              days: parent2Days?.length
                ? parent2Days.map((d) => ({ day: d }))
                : combo.parent2?.days || [],
            },
            children: updatedChildren,
          };
        }
      })
    );

    // mirror update for V2
    setParentCombinationsV2((prev) =>
      prev.map((combo) => {
        if ((combo.id || combo.coparent_combination_id) !== activeComboId)
          return combo;

        const normalizedScheduleType =
          scheduleType.id === 42
            ? {
                id: 42,
                label: `<strong>Parent 1:</strong> ${parent1Days.join(
                  ", "
                )} <br> <strong>Parent 2:</strong> ${parent2Days.join(", ")}`,
              }
            : { id: scheduleType.id, label: scheduleType.label };

        if (isSameScheduleForAll) {
          const cleanedChildren = combo.children.map((child) => {
            // const { parent1Days, parent2Days, scheduleType, ...rest } = child;
            return {
              ...child,
              scheduleType: normalizedScheduleType,
              schedule_type_id: normalizedScheduleType.id,
              parent1: {
                ...child.parent1,
                days: parent1Days,
                selected_days: parent1Days,
              },
              parent2: {
                ...child.parent2,
                days: parent2Days,
                selected_days: parent2Days,
              },
            };
          });

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType: normalizedScheduleType,
            parent1: { ...combo.parent1, days: parent1Days },
            parent2: { ...combo.parent2, days: parent2Days },
            children: cleanedChildren,
          };
        } else {
          const updatedChildren = combo?.children.map((child) =>
            child.child_id === activeChildId
              ? {
                  ...child,
                  parent1Days,
                  parent2Days,
                  scheduleType: normalizedScheduleType,
                  schedule_type_id: normalizedScheduleType.id,
                  parent1: {
                    ...child.parent1,
                    days: parent1Days,
                    selected_days: parent1Days,
                  },
                  parent2: {
                    ...child.parent2,
                    days: parent2Days,
                    selected_days: parent2Days,
                  },
                }
              : child
          );

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType: undefined,
            parent1: {
              ...combo.parent1,
              days: parent1Days?.length
                ? parent1Days.map((d) => ({ day: d }))
                : combo.parent1?.days || [],
            },
            parent2: {
              ...combo.parent2,
              days: parent2Days?.length
                ? parent2Days.map((d) => ({ day: d }))
                : combo.parent2?.days || [],
            },
            children: updatedChildren,
          };
        }
      })
    );
  };

  const handleSaveTime = (updatedWeeks) => {
    setParentCombinations((prev) =>
      prev.map((combo) => {
        if ((combo.id || combo.coparent_combination_id) !== activeComboId)
          return combo;

        const updatedChildren = combo.children.map((child) => {
          if (child.child_id !== activeChildId) return child;

          // normalize scheduleType
          const normalizedScheduleType =
            child?.scheduleType?.id === 42
              ? {
                  id: 42,
                  label:
                    child?.scheduleType?.label ||
                    `<strong>Parent 1:</strong> ${child?.parent1Days?.join(
                      ", "
                    )} <br> <strong>Parent 2:</strong> ${child?.parent2Days?.join(
                      ", "
                    )}`,
                }
              : child?.scheduleType;

          return {
            ...child,
            weeks: updatedWeeks,
            scheduleType: normalizedScheduleType,
            schedule_type_id: normalizedScheduleType?.id,
          };
        });

        return { ...combo, children: updatedChildren };
      })
    );

    setParentCombinationsV2((prev) =>
      prev.map((combo) => {
        if ((combo.id || combo.coparent_combination_id) !== activeComboId)
          return combo;

        const updatedChildren = combo.children.map((child) => {
          if (child.child_id !== activeChildId) return child;

          const normalizedScheduleType =
            child?.scheduleType?.id === 42
              ? {
                  id: 42,
                  label:
                    child?.scheduleType?.label ||
                    `<strong>Parent 1:</strong> ${child?.parent1Days?.join(
                      ", "
                    )} <br> <strong>Parent 2:</strong> ${child?.parent2Days?.join(
                      ", "
                    )}`,
                }
              : child?.scheduleType;

          return {
            ...child,
            weeks: updatedWeeks,
            scheduleType: normalizedScheduleType,
            schedule_type_id: normalizedScheduleType?.id,
          };
        });

        return { ...combo, children: updatedChildren };
      })
    );
  };

  const updateParentFieldSet = (comboId, parentKey, field, value) => {
    // If updating color, find the full color object and its id
    let colorObj = value;
    let colorId = null;
    if (field === "color") {
      // If value is a string (color hex), find the color object by value
      colorObj =
        colorOptions.find(
          (c) =>
            c.value === value || c.id === value?.id || c.value === value?.value
        ) || value;
      colorId = colorObj.id || colorObj.value || null;
    }

    setParentCombinations((prev) => {
      if (parentKey === "parent1" && field === "color") {
        // Set the same color for all parent1s
        return prev.map((combo) => ({
          ...combo,
          parent1: {
            ...combo.parent1,
            color: colorObj,
            color_id: colorId,
          },
        }));
      }

      // For all other fields, update normally
      return prev.map((combo) =>
        (combo.id || combo.coparent_combination_id) === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                [field]: field === "color" ? colorObj : value,
                ...(field === "color" ? { color_id: colorId } : {}),
              },
            }
          : combo
      );
    });

    setParentCombinationsV2((prev) => {
      if (parentKey === "parent1" && field === "color") {
        // Set the same color for all parent1s
        return prev.map((combo) => ({
          ...combo,
          parent1: {
            ...combo.parent1,
            color: colorObj,
            color_id: colorId,
          },
        }));
      }

      // For all other fields, update normally
      return prev.map((combo) =>
        (combo.id || combo.coparent_combination_id) === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                [field]: field === "color" ? colorObj : value,
                ...(field === "color" ? { color_id: colorId } : {}),
              },
            }
          : combo
      );
    });
  };
  const onNameChange = (comboId, parentKey, newName) => {
    setParentCombinations((prev) =>
      prev.map((combo) =>
        (combo.id || combo.coparent_combination_id) === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                nickname: newName,
              },
            }
          : combo
      )
    );
    setParentCombinationsV2((prev) =>
      prev.map((combo) =>
        (combo.id || combo.coparent_combination_id) === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                nickname: newName,
              },
            }
          : combo
      )
    );
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    hasSentInvite && getCoparentEdit();
  }, []);

  const style = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  const handleOk = () => {
    // any save logic here
    onCancel(); // close modal after save
  };
  const getTimeSechudule = (comboId, childId = null) => {
    const comboV2 = parentCombinationsV2?.find(
      (c) => (c?.id || c?.coparent_combination_id) == comboId
    );
    // console.log(comboV2, "comboV2");

    let childV2 = null;

    if (
      comboV2?.isSameScheduleForAll ||
      comboV2.apply_same_settings_for_children
    ) {
      childV2 = comboV2?.children?.[0]; // If same schedule for all, just get the first child
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 40
      ) {
        if (childV2?.weeks && childV2?.weeks?.length) {
          return true;
        } else {
          return false;
        }
      }
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 41
      ) {
        if (childV2?.week_schedules && childV2?.week_schedules?.length) {
          return true;
        } else {
          return false;
        }
      }
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 42
      ) {
        // console.log(childV2);

        if (childV2?.parent1 && childV2?.parent2) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      childV2 = comboV2?.children?.find(
        (c) => (c?.id || c?.child_id) == childId
      );
    }
    //  const childV2 = comboV2?.children?.find(c => c?.id || c?.child_id  == childId);
    if (
      (childV2?.schedule_type || childV2?.scheduleType?.label) &&
      childV2?.schedule_type_id == 40
    ) {
      if (childV2?.weeks && childV2?.weeks?.length) {
        return true;
      } else {
        return false;
      }
    }
    if (
      (childV2?.schedule_type || childV2?.scheduleType?.label) &&
      childV2?.schedule_type_id == 41
    ) {
      if (childV2?.week_schedules && childV2?.week_schedules?.length) {
        return true;
      } else {
        return false;
      }
    }
    if (
      (childV2?.schedule_type || childV2?.scheduleType?.label) &&
      childV2?.schedule_type_id == 42
    ) {
      const p1 =
        Array.isArray(childV2?.parent1?.selected_days) &&
        childV2.parent1.selected_days.length > 0;
      const p2 =
        Array.isArray(childV2?.parent2?.selected_days) &&
        childV2.parent2.selected_days.length > 0;
      return p1 && p2;
    }
  };

  // const onChangeSwitch = (checked) => {
  //   console.log(`switch to ${checked}`);
  // };
  const addCoParent = () => {
    if (coParents.length >= 2) {
      message.warning("You can only add up to 2 co-parents.");
      return;
    }
    const isValid = coParents.every(
      (parent) => parent.email && /\S+@\S+\.\S+/.test(parent.email)
    );

    if (!isValid) {
      message.error(
        "Please enter a valid email for all existing co-parents before adding another."
      );
      return;
    }

    // Set all existing parents' `isExpanded` to false before adding a new one
    const updatedCoParents = coParents.map((parent) => ({
      ...parent,
      isExpanded: false, // Collapse all existing parents
    }));

    // Add new co-parent with collapsed state
    setCoParents([
      ...updatedCoParents,
      {
        email: "",
        permission: 1,
        children: [],
        newChildName: "",
        isAddingChild: false,
        isExpanded: true, // New co-parent starts with collapsed state
        emailError: "",
      },
    ]);
  };

  const toggleExpand = (index) => {
    const updated = coParents.map((parent, i) => ({
      ...parent,
      isExpanded: i === index ? !parent.isExpanded : false, // Only toggle the clicked parent's expand state
    }));
    setCoParents(updated);
  };
  const removeCoParent = (index) => {
    setCoParents((prev) => {
      const updated = [...prev];
      const deletedParent = updated[index];

      // track backend combination for deletion
      if (deletedParent.combination_id) {
        setDeletedCombinations((prevDeleted) => [
          ...prevDeleted,
          deletedParent.combination_id,
        ]);
      }

      // reset UI slot so user can re-add
      updated[index] = {
        email: "",
        permission: 1,
        children: [],
        isAddingChild: false,
        newChildName: "",
        isExpanded: true,
        emailError: "",
        removedChildren: [],
        combination_id: null, // ensures treated as new if user fills again
      };

      return updated;
    });
  };

  const handleEditChild = (parentIndex, childIndex) => {
    setEditingIndex({ parent: parentIndex, child: childIndex });
    setEditModeName(coParents[parentIndex].children[childIndex].name); // Load child’s name into the input field
  };
  const handleEditConfirm = (parentIndex, childIndex) => {
    const updated = [...coParents];
    const child = updated[parentIndex].children[childIndex];

    child.name = editModeName;

    // Mark as updated if it's an existing DB child
    if (child.child_id) {
      child.isUpdated = true;
    }

    setCoParents(updated);
    setEditingIndex({ parent: null, child: null });
    setEditModeName("");
  };
  const handleEditCancel = () => {
    // Reset the editing state for both parent and child
    setEditingIndex({ parent: null, child: null });

    // Clear the current child name from the edit input field
    setEditModeName("");
  };
  const handleDeleteChild = (parentIndex, childIndex) => {
    Modal.confirm({
      title: "Delete Child",
      content: "Are you sure you want to remove this child?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        setCoParents((prev) => {
          const updated = [...prev];
          const removedChild = updated[parentIndex].children[childIndex];

          if (removedChild.child_id) {
            updated[parentIndex].removedChildren = [
              ...(updated[parentIndex].removedChildren || []),
              removedChild,
            ];
          }

          updated[parentIndex].children.splice(childIndex, 1); // remove from active list
          return updated;
        });
      },
    });
  };
  const updateParentField = (index, field, value) => {
    const updated = [...coParents];
    updated[index][field] = value;

    // Basic validation for email
    if (field === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      updated[index].emailError = !emailRegex.test(value)
        ? "Please enter a valid email"
        : "";
    }

    setCoParents(updated);
  };
  useEffect(() => {
    if (
      reminder &&
      (reminder.days > 0 || reminder.hours > 0 || reminder.minutes > 0)
    ) {
      setNotificationSettings((prev) => ({
        ...prev,
        reminderEnabled: 1,
      }));
    }
    // console.log("setNotificationSettings", notificationSettings)
  }, [reminder]);
  const handleSubmit = async () => {
    // Basic email + children validation
    const hasInvalidEmail = coParents.some(
      (parent) => !parent.email || !/\S+@\S+\.\S+/.test(parent.email)
    );
    const hasEmptyChild = coParents.some((parent) =>
      parent.children.some((child) => !child.name.trim())
    );

    if (hasInvalidEmail || hasEmptyChild) {
      message.error("Please fill in all required fields correctly.");
      return;
    }

    const isPermissionSelected = coParents.some(
      (parent) => parent.permission !== 1
    );
    if (!isPermissionSelected) {
      message.error("Please select permission access for co-parent.");
      return;
    }

    const payload = {
      invitations: coParents.map((parent) => ({
        email: parent.email,
        feature: "co_parenting",
        permission_id: Number(parent.permission),
        children: parent.children.map((child) => ({ name: child.name })),
      })),
    };
    // console.log("payload", payload);
    let param = `?start_date=${startDate}&end_date=${endDate}`;

    try {
      setLoading(true);
      // if you're using a spinner or disabling the button
      const response = await fetch(`${URL}/v1/invite/send`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error("Failed to send invitations");
      }

      const result = await response.json();
      setLoading(false);
      message.success("Invitations sent successfully!");
      setHasSentInvite(true);
      setStep(2);
      colorHeaderBackground(param);
      // console.log("Response:", result);

      // Reset or close modal here
      setCoParents([
        {
          email: "",
          isExpanded: true,
          permission: 1,
          children: [],
          emailError: "",
          isAddingChild: false,
          newChildName: "",
        },
      ]);
      getCoparentMetaData();
    } catch (error) {
      setLoading(false);
      console.error("Submission error:", error);
      message.error(
        error.message || "Failed to send invites. Please try again."
      );
    }
  };

  //Update Initial Setup except email
  const updateInitialSetup = async () => {
    const emptyChilds = coParents.some(
      (parent) => !parent.children || parent.children.length === 0
    );

    const isPermissionSelected = coParents.some(
      (parent) => parent.permission !== 1
    );
    if (!isPermissionSelected) {
      message.error("Please select permission access for co-parent.");
      return;
    }

    if (emptyChilds) {
      message.error(
        "Invite cannot be sent. Please add at least one child to update the initial setup."
      );
      return;
    }
    const invitations = [];

    // 1. Deleted combinations
    if (deletedCombinations.length > 0) {
      invitations.push({
        action: "delete_combination",
        deleted_combination_ids: deletedCombinations,
      });
    }

    // 2. Active parents
    coParents.forEach((parent) => {
      if (!parent.email) return; // skip blank slot

      if (!parent.combination_id) {
        // new parent → send_invitation
        invitations.push({
          action: "send_invitation",
          email: parent.email,
          feature: "co_parenting",
          permission_id: Number(parent.permission),
          children: parent.children.map((child) => ({ name: child.name })),
        });
      } else {
        // existing parent → update_combination
        const add_children = parent.children
          .filter((child) => !child.child_id)
          .map((child) => ({ name: child.name }));

        const update_children = parent.children
          .filter((child) => child.child_id && child.isUpdated)
          .map((child) => ({
            child_id: child.child_id,
            name: child.name,
          }));

        const remove_children =
          parent.removedChildren?.map((child) => ({
            child_id: child.child_id,
          })) || [];

        invitations.push({
          action: "update_combination",
          combination_id: parent.combination_id,
          email: parent.email,
          feature: "co_parenting",
          permission_id: Number(parent.permission),
          ...(add_children.length > 0 && { add_children }),
          ...(update_children.length > 0 && { update_children }),
          ...(remove_children.length > 0 && { remove_children }),
        });
      }
    });

    const payload = { invitations };
    // console.log("Final Payload:", payload);

    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/update-schedule-setup-step1`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Failed to update. Please try again."
        );
      }

      message.success("Initial setup updated successfully!");
      getCoparentMetaData(true);
      setStep(2);
    } catch (error) {
      console.error("Submission error:", error);
      message.error(error.message || "Failed to update. Please try again.");
    }
  };

  const handleSubmitSchedule = async () => {
    // Basic email + children validation
    // Function to convert the data into the desired payload format
    const convertToPayload = (data) => {
      // Helper to decide flags based on days and times
      const getScheduleFlags = (days, pickupTime, dropoffTime) => {
        return {
          is_choose_days_enabled:
            Array.isArray(days) && days.length > 0 ? 1 : 0,
          is_pick_and_drop_off_enabled: pickupTime || dropoffTime ? 1 : 0,
        };
      };

      return {
        couples: data.map((item) => {
          const parent1UserId = item.parent1.user_id;
          const parent2UserId = item.parent2.user_id;

          const parentColors = [
            {
              parent1_id: parent1UserId,
              color_id: item.parent1?.color?.id || null,
            },
            {
              parent2_id: parent2UserId,
              color_id: item.parent2?.color?.id || null,
            },
          ];

          const childIds =
            item.isSameScheduleForAll === 1
              ? item.children.map((child) => child.id)
              : null;

          const schedules =
            item.isSameScheduleForAll === 1
              ? [
                  {
                    parent_schedules: [
                      {
                        parent1_id: parent1UserId || null,
                        ...getScheduleFlags(
                          item.parent1?.days,
                          item.parent1?.pickup?.time,
                          item.parent1?.dropoff?.time
                        ),
                        schedule_type_id: item?.scheduleType?.id || null,
                        pickup_days: item.parent1?.days || null,
                        pickup_time: item.parent1?.pickup?.time || null,
                        dropoff_days: item.parent1?.days || null,
                        dropoff_time: item.parent1?.dropoff?.time || null,
                      },
                      {
                        parent2_id: parent2UserId || null,
                        ...getScheduleFlags(
                          item.parent2?.days,
                          item.parent2?.pickup?.time,
                          item.parent2?.dropoff?.time
                        ),
                        schedule_type_id: item?.scheduleType?.id || null,
                        pickup_days: item.parent2?.days || null,
                        pickup_time: item.parent2?.pickup?.time || null,
                        dropoff_days: item.parent2?.days || null,
                        dropoff_time: item.parent2?.dropoff?.time || null,
                      },
                    ],
                  },
                ]
              : item.children.map((child) => ({
                  child_id: child.id,
                  parent_schedules: [
                    {
                      parent1_id: parent1UserId || null,
                      ...getScheduleFlags(
                        child?.parent1Days,
                        child?.parent1Pickup?.time,
                        child?.parent1Dropoff?.time
                      ),
                      schedule_type_id: item?.scheduleType?.id || null,
                      pickup_days: child?.parent1Days || null,
                      pickup_time: child?.parent1Pickup?.time || null,
                      dropoff_days: child?.parent1Days || null,
                      dropoff_time: child?.parent1Dropoff?.time || null,
                    },
                    {
                      parent2_id: parent2UserId || null,
                      ...getScheduleFlags(
                        child?.parent2Days,
                        child?.parent2Pickup?.time,
                        child?.parent2Dropoff?.time
                      ),
                      schedule_type_id: item?.scheduleType?.id || null,
                      pickup_days: child?.parent2Days || null,
                      pickup_time: child?.parent2Pickup?.time || null,
                      dropoff_days: child?.parent2Days || null,
                      dropoff_time: child?.parent2Dropoff?.time || null,
                    },
                  ],
                }));

          return {
            is_shared_across_children: item.isSameScheduleForAll === 1 ? 1 : 0,
            primary_user_coparent_id: item.id,
            primary_user_nickname: item.parent1.name,
            co_parent_nickname: item.parent2.name,
            parent_colors: parentColors,
            child_ids: childIds,
            schedules: schedules,
          };
        }),
      };
    };

    // Convert the data to payload format
    // const payload = convertToPayload(parentCombinations); // Assuming `parentCombinations` is available from props or state
    const transformedData = transformData(parentCombinationsV2);
    const payload = { couple: transformedData }; // Assuming `parentCombinations` is available from props or state
    // console.log("Final Payload", payload);
    let param = `?start_date=${startDate}&end_date=${endDate}`;
    // console.log(payload, "FinalPayload");
    // return;
    try {
      setUpdateLoading(true);
      // if you're using a spinner or disabling the button
      const response = await fetch(
        `${URL}/v1/co-parenting/update-schedule-setup-step2`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        setUpdateLoading(false);
        throw new Error("Failed to save schedule");
      }
      setUpdateLoading(false);
      const result = await response.json();
      message.success("Schedule Saved successfully!");
      colorHeaderBackground(param);
      // console.log("Response:", result);
      setStep(3);
      // Reset or close modal here
      setCoParents([
        {
          email: "",
          isExpanded: true,
          permission: 1,
          children: [],
          emailError: "",
          isAddingChild: false,
          newChildName: "",
        },
      ]);
      getCoparentsMetaData();
    } catch (error) {
      setUpdateLoading(false);
      console.error("Submission error:", error);
      message.error("Failed to save schedule. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  const handleSubmitScheduleDecider = () => {
    if (!metadata || !metadata.setup_info) return;

    if (metadata.setup_info.status === 0) {
      handleCreateSchedule(); // call create if status = 0
    } else {
      handleSubmitSchedule(); // otherwise update
    }
  };

  const handleNotificationDecider = () => {
    if (!metadata || !metadata.setup_info) return;

    if (metadata.setup_info.notification_status === 0) {
      saveSetupNotification(); // call create if status = 0
    } else {
      saveNotification(); // otherwise update
    }
  };

  const handleCreateSchedule = async () => {
    // Basic email + children validation
    // Function to convert the data into the desired payload format
    const transformedData = transformData(
      JSON.parse(JSON.stringify(parentCombinationsV2))
    );
    // console.log("transformedData", { transformedData });
    let finalPayload = {
      couple: transformedData,
      setup_status: "schedule_saved",
    };
    try {
      setLoading(true);
      // if you're using a spinner or disabling the button
      const response = await fetch(`${URL}/v1/co-parenting/schedule-setup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(finalPayload),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error("Failed to schedule setup");
      }

      const result = await response.json();
      setLoading(false);
      message.success("Schedule saved successfully");
      setStep(3);
      // console.log("Response:", result);

      // Reset or close modal here
      setCoParents([
        {
          email: "",
          isExpanded: true,
          permission: 1,
          children: [],
          emailError: "",
          isAddingChild: false,
          newChildName: "",
        },
      ]);
      getCoparentMetaData();
    } catch (error) {
      setLoading(false);
      console.error("Submission error:", error);
      message.error(
        error.message || "Failed to send invites. Please try again."
      );
    }
  };
  const transformData = (data) => {
    return data.map((combo) => {
      const {
        coparent_combination_id,
        parent1,
        parent2,
        children,
        apply_same_settings_for_children,
      } = combo;

      return {
        coparent_combination_id,
        parent1: {
          name: parent1.name,
          nickname: parent1.nickname || parent1.name,
          email: parent1.email,
          color_id: parent1.color_id || parent1.color?.id || null,
          color: parent1.color || null,
        },
        parent2: {
          name: parent2.name,
          nickname: parent2.nickname || parent2.name,
          email: parent2.email,
          color_id: parent2.color_id || parent2.color?.id || null,
          color: parent2.color || null,
        },
        apply_same_settings_for_children,
        children: children
          .map((child) => {
            const scheduleTypeId =
              child.scheduleType?.id || child.schedule_type_id;

            // --- Alternate Weeks ---
            if (scheduleTypeId == 40) {
              return {
                child_id: child.child_id,
                child_name: child.child_name,
                schedule_type_id: "40",
                schedule_type: "alternate_weeks",
                rotation_starting_parent: child.rotation_starting_parent,
                weeks: Array.isArray(child.weeks)
                  ? child.weeks.flatMap((week) => {
                      // If week is already in flat format (has week_number directly)
                      if (week.week_number) {
                        return {
                          ...week,
                          dropoff_time: week.dropoff_time || null,
                          pickup_time: week.pickup_time || null,
                        };
                      }

                      // If week has nested week_number1 / week_number2 keys
                      const transformed = [];
                      if (week.week_number1) {
                        transformed.push({
                          ...week.week_number1,
                          dropoff_time: week.week_number1.dropoff_time || null,
                          pickup_time: week.week_number1.pickup_time || null,
                        });
                      }
                      if (week.week_number2) {
                        transformed.push({
                          ...week.week_number2,
                          dropoff_time: week.week_number2.dropoff_time || null,
                          pickup_time: week.week_number2.pickup_time || null,
                        });
                      }
                      return transformed;
                    })
                  : [],
                applySameSettings: child.applySameSettings || "0",
                modified: child.modified || 0,
              };
            }
            // --- 2-2-3 Rotation ---
            if (scheduleTypeId == 41) {
              const weeksArray = (child.week_schedules || [])
                .flatMap((item) => {
                  if (!item) return [];

                  // If already flat: { week_number, segments, ... }
                  if (item.week_number || Array.isArray(item.segments)) {
                    return [item];
                  }

                  // If nested under week_number1 / week_number2 keys
                  return Object.values(item).filter(Boolean);
                })
                .map((w) => ({
                  week_number: Number(w.week_number),
                  segments: Array.isArray(w.segments) ? w.segments : [],
                  parent1_id:
                    Number(w.week_number) === 1
                      ? w.parent1_id || couple?.parent1?.user_id
                      : null,
                  parent2_id:
                    Number(w.week_number) === 2
                      ? w.parent2_id || couple?.parent2?.user_id
                      : null,
                }));
              return {
                child_id: child.child_id,
                child_name: child.child_name,
                schedule_type_id: "41",
                schedule_type: "2-2-3_rotation",
                rotation_starting_parent: child.rotation_starting_parent,
                week_schedules: weeksArray,
                applySameSettings: child.applySameSettings || "0",
                modified: child.modified || 0,
              };
            }

            // --- Custom Days ---
            if (scheduleTypeId == 42) {
              return {
                child_id: child.child_id,
                // child_name: child.child_name,
                schedule_type_id: "42",
                // schedule_type: child.schedule_type || "custom_days",
                parent1: {
                  parent1_id:
                    child.parent1.parent1_id || couple?.parent1?.user_id,
                  apply_same_time_all_days:
                    child.parent1?.apply_same_time_all_days || 0,
                  selected_days: child.parent1?.selected_days || [],
                  days:
                    (child.parent1?.days || []).map((item) => ({
                      day: !Array.isArray(item.day) ? [item.day] : item.day,
                      responsible_for: item.responsible_for,
                      pickup_time: item.pickup_time,
                      dropoff_time: item.dropoff_time,
                    })) || [],
                  responsible_for: child.parent1?.responsible_for,
                  pickup_time:
                    parent1?.pickup_time ?? child.parent1?.pickup_time,
                  dropoff_time:
                    parent1?.dropoff_time ?? child.parent1?.dropoff_time,
                },
                parent2: {
                  parent2_id:
                    child.parent2.parent2_id || couple?.parent2?.user_id,
                  apply_same_time_all_days:
                    child.parent2?.apply_same_time_all_days || 0,
                  selected_days: child.parent2?.selected_days || [],
                  days:
                    (child.parent2?.days || []).map((item) => ({
                      day: !Array.isArray(item.day) ? [item.day] : item.day,
                      responsible_for: item.responsible_for,
                      pickup_time: item.pickup_time,
                      dropoff_time: item.dropoff_time,
                    })) || [],
                  responsible_for: child.parent2?.responsible_for,
                  pickup_time:
                    parent1?.pickup_time ?? child.parent2?.pickup_time,
                  dropoff_time:
                    parent2?.dropoff_time ?? child.parent2?.dropoff_time,
                },
                modified: child.modified || 0,
              };
            }

            return null;
          })
          .filter(Boolean),
      };
    });
  };

  const getCoparentEdit = async () => {
    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/view-setup/step-one`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.code == 200) {
        const transformedData = result.data.map((item) => ({
          email: item.parent2.email,
          permission: item.parent2.permissions[0]?.id || null,
          children: item.children.map((child) => ({
            child_id: child.id,
            name: child.name,
          })),
          isExpanded: false,
          emailError: "",
          isAddingChild: false,
          newChildName: "",
          combination_id: item.id || item.coparent_combination_id,
          removedChildren: [],
        }));
        setCoParents(transformedData);

        // console.log("Transformed Co-parent Data:", transformedData);

        // You can now use `transformedData` to set state or further processing
        // Example: setCoparents(transformedData);
      } else {
        console.error("Invalid response from server:", result);
      }
    } catch (error) {
      console.error("Error fetching co-parent data:", error);
    }
  };
  const getCoparentSedule = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${URL}/v1/co-parenting/view-setup/step-two`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.code == 200) {
        // console.log("getCoparentSedule", result.data);
        setSameScheduleForAll(
          result.data &&
            result.data.length &&
            result.data[0]?.apply_same_settings_for_children
        );
        setParentCombinationsV2(result.data);
        setParentCombinations(result.data);
        setLoading(false);
        // You can now use `transformedData` to set state or further processing
        // Example: setCoparents(transformedData);
      } else {
        console.error("Invalid response from server:", result);
      }
    } catch (error) {
      console.error("Error fetching co-parent data:", error);
      setLoading(false);
    }
  };
  const getStepThree = async () => {
    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/view-setup/step-three`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.code == 200) {
        // console.log("step-three result.data:", result.data);
        if (result.data) {
          let notificationObj = {
            push: Number(result.data.is_push_notification_enabled),
            email: Number(result.data.is_email_summaries_enabled),
            calendar: Number(result.data.is_calendar_sync_enabled),
            reminderEnabled: result.data.reminder_offset ? 1 : 0,
            reminder_offset: result.data.reminder_offset,
          };
          // console.log("notificationObj",notificationObj)
          let reminderOffset = Number(result.data.reminder_offset) || 0;
          const days = Math.floor(reminderOffset / (24 * 60));
          const hours = Math.floor((reminderOffset % (24 * 60)) / 60);
          const minutes = reminderOffset % 60;
          // console.log("days::hours::minutes", days, hours, minutes);
          setReminder({ days, hours, minutes });
          // setReminder(result.data.reminder_offset);
          setNotificationSettings(notificationObj);
        }
        // You can now use `transformedData` to set state or further processing
        // Example: setCoparents(transformedData);
      } else {
        console.error("Invalid response from server:", result);
      }
    } catch (error) {
      console.error("Error fetching co-parent data:", error);
    }
  };

  const handleSkip = () => {
    // console.log("Skipping co-parent invite");
    setStep(2);
  };
  const handleEditClick = (parentIndex, childIndex) => {
    setEditingIndex({ parent: parentIndex, child: childIndex });
    setEditModeName(coParents[parentIndex].children[childIndex].name);
  };
  const handleAddChild = (index) => {
    const updated = [...coParents];
    updated[index] = {
      ...updated[index],
      isAddingChild: true,
      newChildName: "", // Ensure this is initialized
    };
    setCoParents(updated);
  };

  const handleChildInputChange = (index, value) => {
    const updated = [...coParents];
    updated[index].newChildName = value;
    setCoParents(updated);
  };

  const handleConfirmAddChild = (index) => {
    const updated = [...coParents];
    const name = updated[index].newChildName.trim();
    if (!name) return;

    // Always push as a new child (no child_id, no isUpdated)
    updated[index].children.push({
      name,
      child_id: null, // make it explicit so filter works cleanly
      isUpdated: false, // new children should never be marked as updated
    });

    updated[index].isAddingChild = false;
    updated[index].newChildName = "";
    setCoParents(updated);
  };

  const handleCancelAddChild = (index) => {
    const updated = [...coParents];
    updated[index].isAddingChild = false;
    updated[index].newChildName = "";
    setCoParents(updated);
  };

  const getCoparentMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/co-parenting/metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setMetadata(data.data);
      if (data.code == 200) {
        const { permissions, features, colors, schedule_types, couples } =
          data.data;

        // Permissions with rich label
        const permissionOptions = permissions.map((perm) => ({
          value: perm.id,
          label: (
            <div>
              <strong>{perm.name}</strong>
              {perm.description ? ` – ${perm.description}` : ""}
            </div>
          ),
        }));

        // Features (e.g., for checkbox or select)
        const featureOptions = features.map((feature) => ({
          value: feature.key,
          label: feature.label,
        }));

        // Colors (use for color selection UI)
        const colorOptions = colors.map((color) => ({
          value: color.id,
          label: color.label_name, // you might render color swatches instead
        }));

        // Schedule Types
        const scheduleTypeOption = schedule_types.map((type) => ({
          value: type.id,
          label: type.label_name,
        }));
        let customParentIndex = 1;

        const formattedParentCombinations = couples.map((couple) => {
          let parent2Name = couple.parent2?.name;

          if (!parent2Name || parent2Name === "") {
            parent2Name = `Parent ${customParentIndex++}`;
          }

          return {
            id: couple.id,
            parent1: {
              name: couple.parent1?.name || `Parent 1`,
              email: couple.parent1?.email || "",
              color: couple.parent1?.color || { id: null, name: "#ccc" },
              user_id: couple.parent1?.user_id || null,
            },
            parent2: {
              name: parent2Name,
              email: couple.parent2?.email || "",
              color: couple.parent2?.color || { id: null, name: "#ccc" },
              user_id: couple.parent2?.user_id || null,
            },
            children: (couple.children || []).map((child) => ({
              id: Number(child.id),
              name: child.name,
              chooseDays: "",
              times: "",
              parent1: {},
              parent2: {},
            })),
            sameScheduleForAll: false,
          };
        });

        // setParentCombinations(formattedParentCombinations);
        // setParentCombinationsV2(formattedParentCombinations)
        // Update state
        setPermissionOptions(permissionOptions);
        setScheduleTypeOptions(scheduleTypeOption);
        // setPriority(data.data.priority)
        // setRadioMeta(data.data.progress_status)
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
      // console.log("scheduleTypeOption>>>>>", scheduleTypeOptions);
    } catch (error) {}
  };

  useEffect(() => {
    getCoparentMetaData();
  }, [step]);
  const getScheduleLabel = (value) => {
    const found =
      scheduleTypeOptions &&
      scheduleTypeOptions.find((opt) => opt.value == value);
    return found ? found.label : "No Days selected";
  };

  const handleSaveReminder = (value) => {
    // console.log("Selected co-parent reminder:", value);
    setReminder(value);
    // handle save logic here
  };
  const saveNotification = async () => {
    // console.log("reminder", reminder);
    // Calculate reminder offset (in minutes)
    const reminderOffset =
      (reminder?.days || 0) * 24 * 60 +
      (reminder?.hours || 0) * 60 +
      (reminder?.minutes || 0);

    const payload = {
      is_push_notification_enabled: notificationSettings.push,
      is_email_summaries_enabled: notificationSettings.email,
      is_calendar_sync_enabled: notificationSettings.calendar,
      is_reminder_enabled: notificationSettings.reminderEnabled ? 1 : 0,
      reminder_offset: notificationSettings.reminder_offset || null,
    };
    try {
      setUpdateLoading(true);
      const response = await fetch(
        `${URL}/v1/co-parenting/update-schedule-setup-step3`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
          redirect: "manual", // prevents automatic following of 302
        }
      );

      if (response.status === 302) {
        const redirectURL = response.headers.get("Location");
        console.warn("Redirected to:", redirectURL);
        throw new Error(
          "Unexpected redirect. Please check authentication or endpoint."
        );
      }

      if (!response.ok) {
        setUpdateLoading(false);
        const errorData = await response.json();
        console.error("API Error Response:", errorData);
        throw new Error("Failed to save notification settings.");
      }

      const result = await response.json();
      setUpdateLoading(false);
      // console.log("Saved successfully:", result);

      message.success("Notification Setup updated successfully");
      // Proceed to next step
      onCancel();
    } catch (error) {
      setUpdateLoading(false);
      console.error("Save failed:", error.message || error);
    }
  };

  const saveSetupNotification = async () => {
    // Calculate reminder offset (in minutes)
    const reminderOffset =
      (reminder?.days || 0) * 24 * 60 +
      (reminder?.hours || 0) * 60 +
      (reminder?.minutes || 0);

    const payload = {
      is_push_notification_enabled: notificationSettings.push,
      is_email_summaries_enabled: notificationSettings.email,
      is_calendar_sync_enabled: notificationSettings.calendar,
      is_reminder_enabled: notificationSettings.reminderEnabled ? 1 : 0,
      reminder_offset: notificationSettings.reminder_offset || null,
      notification_setup_status: "completed",
    };
    // console.log("update-schedule-setup-step3:", payload);
    // return;
    setLoading(true);
    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/notification-setup`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        setLoading(false);
        const errorData = await response.json();
        console.error("API Error Response:", errorData);
        throw new Error("Failed to save notification settings.");
      }

      const result = await response.json();
      setLoading(false);
      // console.log("Saved successfully:", result);
      onCancel();
      const params = `?start_date=${startDate}&end_date=${endDate}`;
      colorHeaderBackground(params);
      fetchAndSetEvents(startDate, endDate);
      // Proceed to next step
      // setStep(5);
    } catch (error) {
      setLoading(false);
      console.error("Save failed:", error.message || error);
    }
  };

  const getAllUsedColors = () => {
    const usedColors = [];
    parentCombinations.forEach((combo) => {
      if (combo.parent1.color?.name) usedColors.push(combo.parent1.color.name);
      if (combo.parent2.color?.name) usedColors.push(combo.parent2.color.name);
    });
    return usedColors;
  };
  const sameScheduleForAllChange = (comboId, checked) => {
    setParentCombinations((prev) =>
      prev.map((c) =>
        c.coparent_combination_id === comboId
          ? {
              ...c,
              children:
                c.children &&
                c.children.length &&
                c.children.map((child) => ({
                  child_id: child.child_id,
                  child_name: child.child_name,
                  schedule_type_id: "",
                  schedule_type: "",
                })),
              sameScheduleForAll: checked,
              isSameScheduleForAll: checked,
              apply_same_settings_for_children: checked ? 1 : 0,
            }
          : c
      )
    );
    setParentCombinationsV2((prev) =>
      prev.map((c) =>
        c.coparent_combination_id === comboId
          ? {
              ...c,
              sameScheduleForAll: checked,
              isSameScheduleForAll: checked,
              apply_same_settings_for_children: checked ? 1 : 0,
              children:
                c.children &&
                c.children.length &&
                c.children.map((child) => ({
                  child_id: child.child_id,
                  child_name: child.child_name,
                  schedule_type_id: "",
                  schedule_type: "",
                })),
            }
          : c
      )
    );
    setSameScheduleForAll(checked ? 1 : 0);
  };
  return (
    <>
      <div>{/* <Button onClick={showModal}>Co-Parent</Button> */}</div>
      <div>
        <Modal
          title="Co-Parent"
          open={isOpen}
          onCancel={onCancel}
          footer={false}
          onOk={handleOk}
          maskClosable={false}
        >
          {step === 1 && (
            <>
              <div className="modal-content">
                <div
                  className="modal-content"
                  style={{
                    marginBottom: "30px",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "20px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <h2
                      className="modal-title-step2"
                      style={{ textAlign: "center" }}
                    >
                      Invite Co-Parent
                    </h2>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p className="modal-description">
                      Both parents can add and manage events
                    </p>
                    <img
                      src={coparent}
                      width={180}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  {coParents.map((parent, index) => {
                    if (!parent) return null;
                    return (
                      <div
                        key={index}
                        style={{ width: "100%", marginBottom: "30px" }}
                      >
                        {parent.email && !parent.emailError && (
                          <div className="username-box-1">
                            <Button
                              // style={{ width: "100%" }}
                              onClick={() => toggleExpand(index)}
                            >
                              {parent.email} <EditOutlined />
                            </Button>
                            {/* <Button
                              className="deleteIcon"
                              icon={<DeleteOutlined />}
                              onClick={() => removeCoParent(index)}
                            /> */}
                          </div>
                        )}
                        {parent.isExpanded && (
                          <>
                            <div className="coparent-div-1">
                              <h4>Enter Co-Parent’s Email Address</h4>
                              <Form.Item
                                name={`email-${index}`}
                                validateStatus={
                                  parent.emailError ? "error" : ""
                                }
                                help={parent.emailError}
                                rules={[
                                  {
                                    required: true,
                                    type: "email",
                                    message: "Please enter a valid email",
                                  },
                                ]}
                              >
                                <FloatLabel
                                  label="Email"
                                  value={parent.email}
                                  required
                                >
                                  <Input
                                    value={parent.email}
                                    placeholder=""
                                    disabled={hasSentInvite}
                                    style={{ width: "100%" }}
                                    onChange={(e) =>
                                      updateParentField(
                                        index,
                                        "email",
                                        e.target.value
                                      )
                                    }
                                  />
                                </FloatLabel>
                              </Form.Item>
                            </div>
                            <div className="coparent-div">
                              <h4>Permission Settings</h4>
                              <Radio.Group
                                options={permissionOptions}
                                value={Number(parent.permission)}
                                onChange={(e) =>
                                  updateParentField(
                                    index,
                                    "permission",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            <div className="addChildrenSection">
                              <h4>
                                Add Child(ren) Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </h4>

                              {parent.children.map((child, childIndex) => (
                                <div
                                  key={childIndex}
                                  style={{
                                    marginBottom: "10px",
                                    display: "inline-flex",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  {editingIndex.parent === index &&
                                  editingIndex.child === childIndex ? (
                                    <>
                                      <input
                                        type="text"
                                        value={editModeName}
                                        className="childtext"
                                        onChange={(e) =>
                                          setEditModeName(e.target.value)
                                        }
                                        style={{
                                          padding: "15px",
                                          width: "100%",
                                          border: "1px solid #9A4FE0",
                                          fontSize: "14px",
                                        }}
                                      />
                                      <button
                                        className="confirnIcon"
                                        onClick={() =>
                                          handleEditConfirm(index, childIndex)
                                        }
                                        style={{
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        ✓
                                      </button>
                                      <button
                                        className="confirnIcon"
                                        onClick={handleEditCancel}
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        ✕
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <span
                                        className="childEdit"
                                        style={{
                                          width: "100%",
                                          fontSize: "14px",
                                          padding: "15px",
                                          backgroundColor: "#F7F8FA",
                                          borderRadius: "6px",
                                          border: "1px solid #E1E6EF",
                                        }}
                                      >
                                        {child.name}
                                      </span>
                                      <button
                                        className="confirnIcon test"
                                        onClick={() =>
                                          handleEditClick(index, childIndex)
                                        }
                                        style={{
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <EditOutlined />
                                      </button>
                                      <button
                                        className="confirnIcon"
                                        onClick={() =>
                                          handleDeleteChild(index, childIndex)
                                        }
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </button>
                                    </>
                                  )}
                                </div>
                              ))}

                              {parent.isAddingChild ? (
                                <div
                                  className="new123"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "10px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="Enter child's name"
                                    className="childtext"
                                    value={parent.newChildName}
                                    onChange={(e) =>
                                      handleChildInputChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      padding: "12px",
                                      width: "100%",
                                      border: "1px solid #9A4FE0",
                                      fontSize: "14px",
                                      borderRadius: "4px",
                                    }}
                                  />
                                  <button
                                    className="confirnIcon"
                                    onClick={() => handleConfirmAddChild(index)}
                                    style={{
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ✓
                                  </button>
                                  <button
                                    className="confirnIcon"
                                    onClick={() => handleCancelAddChild(index)}
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ) : (
                                <div className="add-another-child">
                                  Add Another Child
                                  <Button
                                    shape="circle"
                                    icon={<PlusOutlined />}
                                    size="small"
                                    style={{
                                      marginLeft: "6px",
                                      backgroundColor: "#9A4FE0",
                                      color: "white",
                                      border: "none",
                                      padding: "15px",
                                      fontSize: "12px",
                                      opacity:
                                        coParents[index]?.children?.length >= 3
                                          ? 0.5
                                          : 1,
                                      cursor:
                                        coParents[index]?.children?.length >= 3
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                    onClick={() => handleAddChild(index)}
                                    disabled={
                                      coParents[index]?.children?.length >= 3
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}

                  {coParents.length < 2 && (
                    <div
                      className="add-another"
                      style={{
                        textAlign: "center",
                        marginTop: "50px",
                        justifyContent: "center",
                        display: "none",
                      }}
                    >
                      Add another email
                      <Button
                        shape="circle"
                        icon={<PlusOutlined />}
                        size="small"
                        style={{
                          marginLeft: "6px",
                          backgroundColor: "#9A4FE0",
                          color: "white",
                          border: "none",
                          padding: "15px",
                          fontSize: "12px",
                        }}
                        onClick={addCoParent}
                      />
                    </div>
                  )}

                  {hasSentInvite ? (
                    <Button
                      type="primary"
                      className="modal-btn"
                      onClick={updateInitialSetup} // calls update API
                    >
                      Update & Continue
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      className="modal-btn"
                      onClick={handleSubmit} // calls send API
                      disabled={loading}
                    >
                      {loading ? "Sending invite" : "Send invite"}
                    </Button>
                  )}
                  <Button className="modal-btn-skip" onClick={handleSkip}>
                    Skip & Set Later
                  </Button>
                </div>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <div className="modal-content">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    // style={{ display: "none" }}
                    onClick={() => setStep(1)}
                  >
                    Back
                  </Button>
                </div>

                <h2 className="modal-title-step2">
                  Set Up Your Parenting Schedule
                </h2>
                <img
                  src={coparent}
                  width={180}
                  style={{ marginBottom: "10px" }}
                />

                <div className="coparent-div coparent-div-1">
                  {parentCombinationsV2 && parentCombinationsV2.length > 0 ? (
                    <Collapse
                      accordion
                      expandIcon={({ isActive }) => (
                        <DownOutlined
                          style={{ color: "#9A4FE0" }}
                          rotate={isActive ? 0 : 270}
                        />
                      )}
                      expandIconPosition="end"
                      bordered={false}
                      className="custom-collapse"
                    >
                      {parentCombinationsV2.map((combo) => (
                        <Panel
                          header={
                            <div className="collapse-header-text">
                              {combo.parent1.nickname ||
                                combo.parent1.name ||
                                "Parent 1"}
                              -
                              {combo.parent2.nickname ||
                                combo.parent2.name ||
                                "Parent 2"}
                            </div>
                          }
                          key={combo.id}
                          headerClass="collapseHeader"
                          className="custom-panel"
                        >
                          <div className="custom-content-box">
                            {/* Parent 1 */}
                            <div className="parent-section">
                              <h3>Parent 1</h3>
                              <ColorDropdownWithName
                                value={
                                  combo.parent1.color ||
                                  Number(combo.parent1.color_id)
                                }
                                name={combo?.parent1.nickname ?? "Parent 1"}
                                onColorChange={(color) =>
                                  updateParentFieldSet(
                                    combo.id || combo.coparent_combination_id,
                                    "parent1",
                                    "color",
                                    color
                                  )
                                }
                                onNameChange={(name) =>
                                  onNameChange(
                                    combo.id || combo.coparent_combination_id,
                                    "parent1",
                                    name
                                  )
                                }
                                disabledColor={combo.parent2.color}
                                usedColors={getAllUsedColors()}
                              />

                              <div className="add-coparent">
                                {/* <Input
              className="coParentEmail"
              readOnly
                value={combo.parent1.email}
                onChange={(e) => updateParentFieldSet(combo.id, 'parent1', 'email', e.target.value)}
              /> */}
                                <Form.Item className="floatLabelCoprent">
                                  <FloatLabel
                                    label="Email"
                                    value={combo.parent1.email}
                                  >
                                    <Input
                                      value={combo.parent1.email}
                                      className="coParentEmail"
                                      placeholder=""
                                      readOnly
                                      style={{ width: "100%" }}
                                      onChange={(e) =>
                                        updateParentFieldSet(
                                          combo.id,
                                          "parent1",
                                          "email",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </FloatLabel>
                                </Form.Item>
                              </div>
                            </div>

                            {/* Parent 2 */}
                            <div className="parent-section">
                              <h3>Parent 2</h3>
                              <ColorDropdownWithName
                                value={combo.parent2.color}
                                name={combo?.parent2.nickname ?? "Parent 2"}
                                onColorChange={(color) =>
                                  updateParentFieldSet(
                                    combo.id || combo.coparent_combination_id,
                                    "parent2",
                                    "color",
                                    color
                                  )
                                }
                                onNameChange={(name) =>
                                  onNameChange(
                                    combo.id || combo.coparent_combination_id,
                                    "parent2",
                                    name
                                  )
                                }
                                disabledColor={combo.parent1.color}
                                usedColors={getAllUsedColors()}
                              />

                              <div className="add-coparent">
                                {/* <Input
                readOnly
                className="coParentEmail"
                value={combo.parent2.email}
                onChange={(e) => updateParentFieldSet(combo.id, 'parent2', 'email', e.target.value)}
              /> */}
                                <Form.Item className="floatLabelCoprent">
                                  <FloatLabel
                                    label="Email"
                                    value={combo.parent2.email}
                                  >
                                    <Input
                                      value={combo.parent2.email}
                                      className="coParentEmail"
                                      placeholder=""
                                      readOnly
                                      style={{ width: "100%" }}
                                      onChange={(e) =>
                                        updateParentFieldSet(
                                          combo.id,
                                          "parent2",
                                          "email",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </FloatLabel>
                                </Form.Item>
                              </div>
                            </div>

                            <div
                              className="parentScheduleCheck"
                              style={{ marginBottom: "16px" }}
                            >
                              <h3>Parenting Schedule</h3>
                              <Checkbox
                                checked={
                                  combo.sameScheduleForAll ||
                                  combo.apply_same_settings_for_children
                                }
                                onChange={(e) =>
                                  sameScheduleForAllChange(
                                    combo.id || combo.coparent_combination_id,
                                    e.target.checked
                                  )
                                }
                              >
                                Apply the same schedule to all children
                              </Checkbox>
                            </div>
                            {combo.sameScheduleForAll ||
                            combo.apply_same_settings_for_children ? (
                              <div className="switch-selection">
                                <div
                                  className="btn-switch"
                                  onClick={() =>
                                    handleOpenModal(
                                      combo?.id ||
                                        combo?.coparent_combination_id
                                    )
                                  }
                                >
                                  <div style={{ paddingBottom: "5px" }}>
                                    <p
                                      style={{
                                        margin: "0px",
                                        fontSize: "18px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Choose Days
                                    </p>
                                    <p
                                      style={{
                                        margin: "0px",
                                        fontSize: "12px",
                                        color: "#767A83",
                                      }}
                                      // dangerouslySetInnerHTML={{
                                      //   __html:
                                      //     combo?.scheduleType?.label || combo?.children[0]?.schedule_type ||
                                      //     "No Days selected",
                                      // }}
                                    >
                                      {getScheduleLabel(
                                        combo?.children[0]?.schedule_type_id
                                      )}
                                    </p>
                                  </div>
                                  <Switch
                                    checked={
                                      combo?.scheduleType?.id ||
                                      combo?.children[0]?.schedule_type_id
                                    }
                                  />
                                </div>
                                <div
                                  className="btn-switch"
                                  onClick={() =>
                                    handleOpenModalTime(
                                      combo?.id ||
                                        combo?.coparent_combination_id
                                    )
                                  }
                                >
                                  <div style={{ paddingBottom: "5px" }}>
                                    <p
                                      style={{
                                        margin: "0px",
                                        fontSize: "18px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Pick-up and drop-off times
                                    </p>
                                  </div>
                                  <Switch
                                    checked={getTimeSechudule(
                                      combo.id || combo.coparent_combination_id
                                    )}
                                  />
                                </div>
                              </div>
                            ) : (
                              <Collapse
                                accordion
                                expandIconPosition="end"
                                className="child-collapse"
                                expandIcon={({ isActive }) => (
                                  <DownOutlined
                                    style={{ color: "#ffffff" }}
                                    rotate={isActive ? 0 : 270}
                                  />
                                )}
                              >
                                {combo.children.map((child) => (
                                  <Panel
                                    key={child?.id}
                                    header={
                                      <div className="child-header">
                                        {child?.child_name}
                                      </div>
                                    }
                                    headerClass="child-panel-header"
                                  >
                                    <div className="switch-selection">
                                      <div
                                        className="btn-switch"
                                        onClick={() =>
                                          handleOpenModal(
                                            combo?.id ||
                                              combo?.coparent_combination_id,
                                            child?.id || child?.child_id
                                          )
                                        }
                                      >
                                        <div style={{ paddingBottom: "5px" }}>
                                          <p
                                            style={{
                                              margin: "0px",
                                              fontSize: "18px",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            Choose Days
                                          </p>
                                          <p
                                            style={{
                                              margin: "0px",
                                              fontSize: "12px",
                                              color: "#767A83",
                                            }}
                                            // dangerouslySetInnerHTML={{
                                            //   __html:
                                            //     child?.scheduleType?.label ||
                                            //     "No Days selected",
                                            // }}
                                          >
                                            {getScheduleLabel(
                                              child?.schedule_type_id
                                            )}
                                          </p>
                                        </div>
                                        <Switch
                                          checked={child?.schedule_type_id}
                                          // Check if scheduleType exists and set switch accordingly
                                        />
                                      </div>
                                      <div
                                        className="btn-switch"
                                        onClick={() =>
                                          handleOpenModalTime(
                                            combo?.id ||
                                              combo?.coparent_combination_id,
                                            child?.id || child?.child_id
                                          )
                                        }
                                      >
                                        <div style={{ paddingBottom: "5px" }}>
                                          <p
                                            style={{
                                              margin: "0px",
                                              fontSize: "18px",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            Pick-up and drop-off times
                                          </p>
                                          <p
                                            style={{
                                              margin: "0px",
                                              fontSize: "12px",
                                              color: "#767A83",
                                            }}
                                            // dangerouslySetInnerHTML={{
                                            //   __html:
                                            //     child?.scheduleType?.label ||
                                            //     "No Days selected",
                                            // }}
                                          >
                                            {getTimeSechudule(
                                              combo.id ||
                                                combo.coparent_combination_id,
                                              child?.id || child?.child_id
                                            )}
                                          </p>
                                        </div>
                                        <Switch
                                          checked={
                                            child?.schedule_type_id == 42
                                              ? Array.isArray(
                                                  child?.parent1?.selected_days
                                                ) &&
                                                child.parent1.selected_days
                                                  .length > 0 &&
                                                Array.isArray(
                                                  child?.parent2?.selected_days
                                                ) &&
                                                child.parent2.selected_days
                                                  .length > 0
                                              : getTimeSechudule(
                                                  combo.id ||
                                                    combo.coparent_combination_id,
                                                  child?.id || child?.child_id
                                                )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </Panel>
                                ))}
                              </Collapse>
                            )}
                          </div>
                        </Panel>
                      ))}
                    </Collapse>
                  ) : (
                    <p> Loading Co-parents Data...</p>
                  )}

                  <Button
                    type="primary"
                    className="modal-btn"
                    onClick={handleSubmitScheduleDecider}
                    disabled={loading || updatedLoading}
                  >
                    {updatedLoading || loading
                      ? "Saving schedule..."
                      : "Save Schedule"}
                  </Button>
                  <Button className="modal-btn-skip" onClick={() => setStep(3)}>
                    Skip & Set Later
                  </Button>
                </div>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="modal-content">
                {/* <div style={{width:'100%',display:'flex',justifyContent:'end'}}>
                          <Button onClick={() => setStep(3)}>Back</Button>
                          </div> */}
                <h2 className="modal-title-step2">Stay Notified</h2>
                <img
                  src={coparent}
                  width={180}
                  style={{ marginBottom: "10px" }}
                />
                <div className="switch-selection">
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>
                      Push Notifications
                    </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.push === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            push: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>Email Summaries </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.email === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            email: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>Calender Sync </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.calendar === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            calendar: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div
                    className="btn-switch"
                    onClick={() => setModalVisible(true)}
                  >
                    <div style={{ paddingBottom: "5px" }}>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "18px",
                          marginBottom: "5px",
                        }}
                      >
                        Reminder Timing
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "12px",
                          color: "#767A83",
                        }}
                      >
                        {notificationSettings.reminderEnabled
                          ? notificationSettings.reminder_offset == 60
                            ? "1 hour"
                            : notificationSettings.reminder_offset == 1440
                            ? "1 day"
                            : `${notificationSettings.reminder_offset} minute(s)`
                          : "Not set"}
                      </p>
                    </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={
                          notificationSettings.reminderEnabled ? true : false
                        }
                        onChange={(checked) => {
                          if (checked) {
                            // ✅ Open modal when toggled ON
                            setModalVisible(true);

                            // if no previous value, set a temporary default (like 5 mins)
                            if (!notificationSettings.reminderEnabled) {
                              setNotificationSettings({
                                ...notificationSettings,
                                reminder_offset: 0,
                              });
                            }
                          } else {
                            // ✅ When toggled OFF → clear reminder
                            setNotificationSettings({
                              ...notificationSettings,
                              reminder_offset: 0,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <ReminderModal
                  show={modalVisible}
                  onSave={(minutes) => {
                    setNotificationSettings({
                      ...notificationSettings,
                      reminderEnabled: true, // <-- just flag enabled
                      reminder_offset: minutes, // <-- minutes go here
                    });
                  }}
                  initialMinutes={notificationSettings?.reminder_offset}
                  onCancel={() => setModalVisible(false)}
                  handleClose={() => setModalVisible(false)}
                />
                <Button
                  type="primary"
                  className="modal-btn"
                  onClick={handleNotificationDecider}
                  disabled={updatedLoading || loading}
                >
                  {updatedLoading || loading
                    ? "Saving notifications setup"
                    : "Save"}
                </Button>
                <Button onClick={onCancel} className="modal-btn-skip">
                  Skip & Use Default Settings
                </Button>
              </div>
            </>
          )}

          {isModalOpenChooseDay && (
            <ChooseDays
              open={isModalOpenChooseDay}
              onClose={() => setIsModalOpenChooseDay(false)}
              activeComboId={activeComboId}
              activeChildId={activeChildId}
              parentCombinations={parentCombinations}
              parentCombinationsV2={parentCombinationsV2}
              sameScheduleForAll={sameScheduleForAll}
              scheduleTypeOptions={scheduleTypeOptions}
              modified={1}
              onSave={handleSaveDays}
            />
          )}
          {isModalOpenChooseTime && (
            <ChooseTime
              open={isModalOpenChooseTime}
              onClose={() => setIsModalOpenChooseTime(false)}
              activeComboId={activeComboId}
              activeChildId={activeChildId}
              parentCombinations={parentCombinations}
              sameScheduleForAll={sameScheduleForAll}
              onSave={handleSaveTime}
              parentCombinationsV2={parentCombinationsV2}
              modified={1}
              setParentCombinationsV2={setParentCombinationsV2}
              setParentCombinations={setParentCombinations}
              couples={couples}
            />
          )}
        </Modal>

        <div></div>
      </div>
    </>
  );
};

export default EditCoparent;
